<script>
import resize from '@utils/image-sizer';

export default {
  components: {},
  props: {
    hideDescription: {
      type: Boolean,
      required: false,
    },
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      placeholder: require('@assets/images/placeholder-equipment-list.svg'),
    };
  },
  computed: {
    hasExerciseMetaData() {
      return (
        (this.item &&
          this.item.muscleGroups &&
          this.item.muscleGroups.length) ||
        (this.item.exerciseDifficulty &&
          this.item.exerciseDifficulty.exerciseDifficulty_id)
      );
    },
    hasMuscleGroups() {
      return (
        this.item && this.item.muscleGroups && this.item.muscleGroups.length
      );
    },
    hasCoverPhoto() {
      return (
        this.item &&
        this.item.mediaAssets &&
        this.item.mediaAssets.coverPhoto &&
        this.item.mediaAssets.coverPhoto.url
      );
    },
    hasThumbnailPhoto() {
      return (
        this.item &&
        this.item.mediaAssets &&
        this.item.mediaAssets.thumbnailPhoto &&
        this.item.mediaAssets.thumbnailPhoto.url
      );
    },
    equipPhoto() {
      if (this.hasThumbnailPhoto) {
        return resize(this.item.mediaAssets.thumbnailPhoto.url, 100, 56);
      } else if (this.hasCoverPhoto) {
        return resize(this.item.mediaAssets.coverPhoto.url, 100, 56);
      } else {
        return this.placeholder;
      }
    },
  },
  mounted() {},
  methods: {
    selectItem(item) {
      this.$emit('select-list-item', item);
    },
  },
};
</script>

<template v-if="item && item.label">
  <div class="list-item" @click="selectItem(item)" tabindex="0">
    <BaseThumbnail :image="equipPhoto" />
    <div class="list-item-content">
      <div class="list-item-title">
        <h6
          class="list-item-categories"
          :style="[!hasExerciseMetaData ? { visibility: 'hidden' } : '']"
        >
          <template v-if="hasMuscleGroups">
            <span v-for="(group, i) in item.muscleGroups" :key="i">
              {{ group.label
              }}<span v-if="i + 1 < item.muscleGroups.length">,</span>
            </span>
          </template>
          <span v-if="hasExerciseMetaData && item.exerciseDifficulty">
            | {{ item.exerciseDifficulty.label }}
          </span>
        </h6>
        <h3>{{ item.label }}</h3>
      </div>
      <div class="list-item-description" v-if="!hideDescription">
        <p>{{ item.description }}</p>
      </div>
    </div>
    <slot name="toBaseListItem" />
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.list-item {
  align-items: center;
  border-bottom: 1px solid $color-list-item-border;
  display: flex;
  flex-direction: row;
  padding: 2rem 0 2rem 6rem;
  .add-workout {
    align-items: center;
    color: $color-primary;
    display: flex;
    font-family: $base-font-family;
    font-size: 14px;
    font-style: normal;
    font-weight: 800;
    line-height: 22px;
    margin-left: auto;
    padding-left: 1.5rem;
    padding-right: 2rem;
    white-space: nowrap;
    .action {
      display: none;
      transition: all linear 0.3s;
    }
    .chevron-right {
      margin-left: 2rem;
    }
  }

  &:active,
  &:focus {
    background-color: $color-off-white;
    outline: none;
  }

  &:hover {
    background-color: $color-off-white;
    cursor: pointer;
    .add-workout {
      .action {
        display: unset;
      }
      .action:hover {
        cursor: pointer;
        opacity: 0.6;
      }
    }
  }

  &:first-of-type {
    border-top: 1px solid $color-list-item-border;
  }

  .list-item-icon {
    align-items: center;
    display: flex;
    height: 2.5rem;
    justify-content: center;
    margin-right: 1rem;
    width: 2.5rem;
  }

  .list-item-title {
    h4 {
      color: $color-heading-text;

      small {
        color: $color-text;
        display: block;
        line-height: 1;
      }
    }
  }

  .list-item-categories {
    color: $color-medium-gray-alt;
    font-size: 1.2rem;
    font-weight: 800;
    letter-spacing: 0.1px;
    line-height: 2.2rem;
    text-transform: uppercase;
  }
}
</style>
